import { CognitoUser, CognitoUserPool } from "amazon-cognito-identity-js";

import poolData from "../../../userpool";

/**
 * Shared user pool instance. Auth screens used to construct their own `new CognitoUserPool(poolData)`
 * in each file; import this instead.
 */
export const userPool = new CognitoUserPool(poolData);

interface CognitoError {
	code?: string;
	message?: string;
}

/**
 * Cognito is configured to email a verification *link* (not a code), so this simply re-sends
 * that link. There is no confirmation-code screen to follow it up with.
 */
export function resendVerificationEmail(email: string): Promise<void> {
	return new Promise((resolve, reject) => {
		const cognitoUser = new CognitoUser({ Username: email, Pool: userPool });

		cognitoUser.resendConfirmationCode((err) => {
			if (err) {
				reject(new Error(resendErrorMessage(err as CognitoError)));
				return;
			}
			resolve();
		});
	});
}

function resendErrorMessage(err: CognitoError): string {
	switch (err.code) {
		case "LimitExceededException":
		case "TooManyRequestsException":
			return "Too many attempts, please wait a few minutes before trying again.";
		case "UserNotFoundException":
			return "We couldn't find an account with that email address.";
		case "InvalidParameterException":
			// Cognito uses this when the user is already confirmed.
			return "This account is already verified — try signing in.";
		default:
			return err.message || "We couldn't send the verification email. Please try again.";
	}
}
